import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {RefService} from "../referers/ref.service";


@Component({
	selector: 'ref_status',
	templateUrl: './ref_status.component.html',
})
export class RefStatusComponent implements OnInit, OnChanges {
	@Input() public stats;
	
	refStatus: any = {};
	refInterval: any = null;
	
	constructor(private refService: RefService) {
	}
	
	async ngOnInit() {
		await this.getRefStatus();
	}
	
	async ngOnChanges() {
		await this.getRefStatus();
	}
	
	async getRefStatus() {
		let me = this;
		
		me.refStatus = await me.refService.getRefStatus().toPromise();
		
		if (me.refStatus.isActive === 1) {
			if ( ! me.refInterval) {
				
				clearInterval(me.refInterval);
				me.refInterval = setInterval(async function() {
					me.refStatus = await me.refService.getRefStatus().toPromise();
					
					if (me.refStatus.isActive == 0) {
						clearInterval(me.refInterval);
					}
				}, 30 * 1000);
			}
		} else {
			if (me.refInterval) {
				clearInterval(me.refInterval);
			}
		}
	}
}
